var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFactoryDashboardIcon = function SvgFactoryDashboardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    clipPath: "url(#factory-dashboard-icon_svg__a)",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M10 9v10.75a2 2 0 0 0 2 2h1.75M10 9H8.5M10 9h20m0 0h1.5M30 9v10.75a2 2 0 0 1-2 2h-1.75m-12.5 0h12.5m-12.5 0-1 2.75m13.5-2.75 1 2.75m0 0 .5 1.5m-.5-1.5h-14.5m0 0-.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17v3M20 15v5M24 13v7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "factory-dashboard-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h24v24H8z"
  })))));
};
export { SvgFactoryDashboardIcon as ReactComponent };
export default __webpack_public_path__ + "d80c4ef6760569e9e700ede425174431.svg";